module.exports = __webpack_public_path__ + "static/media/cl.4d2a6ff9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cl.svg
// module id = 87
// module chunks = 0